// extracted by mini-css-extract-plugin
export default {"field_label":"customised-select-box_field_label__rqbG8","error_message":"customised-select-box_error_message__JjZA8"};